import ProductFilter from "./product-filter"

export class BooleanProductFilterModel extends ProductFilter {
  _value = false

  constructor(group, products) {
    super(group, "BOOLEAN")

    this.updateValues(products)
  }

  setValue(val) {
    this._value = !!val
    this._updated(this._value)
  }

  reset() {
    this._value = false
    super.reset()
  }

  matches(product) {
    if (!this._value) return true

    return this.hasEffectOn(product)
  }

  hasEffectOn(product) {
    const index = product.boolean_product_parameter_values.findIndex(
      (param) => param.product_parameter_group.id === this._id,
    )

    return index !== -1
  }

  getState() {
    return {
      ...super.getState(),
      _value: this._value,
    }
  }

  restoreState(state) {
    super.restoreState(state)
    this._value = state._value || false
  }
}
